export const SAVE_NAME = 'SAVE_NAME';
export const RESET_NAME = 'RESET_NAME';
